import React, { ReactElement } from 'react';
import useWindowDimensions from 'shared/hooks/useWindowDimenstion';
import { HeaderButton, HeaderCont, TitleCont } from './Media.styles';
import { CustomTypography } from 'shared/elements/CustomTypography';

interface Props {
  icon: ReactElement;
  title: string;
  subtitle: string;
  contentAction: React.ReactNode;
}

const CommonHeader: React.FC<Props> = ({ icon, title, subtitle, contentAction }) => {
  const { width } = useWindowDimensions();
  return (
    <HeaderCont>
      <div style={{ display: 'flex' }}>
        {icon}
        <TitleCont>
          <CustomTypography fontSize={width < 960 ? 16 : 18}>{title}</CustomTypography>
          <CustomTypography fontSize={width < 960 ? 12 : 15}>{subtitle}</CustomTypography>
        </TitleCont>
      </div>
      <div style={{ display: 'flex', gap: '5px' }}>{contentAction}</div>
    </HeaderCont>
  );
};

export default CommonHeader;

export { HeaderButton };
